export interface ConversationMessage {
  id: string;
  message: string;
  role: 'user' | 'assistant';
  isStreaming?: boolean;
}

export interface ConversationMessagePayload {
  event_id?: number;
  message: string;
  source: 'user' | 'ai';
}

export interface AgentChatResponsePart {
  event_id: number;
  text: string;
  type: 'start' | 'delta' | 'stop';
}

const AUDIO_DIRECTION_TAG_PATTERN = /\[[A-Za-z][A-Za-z\s'-]{0,48}\]\s*/g;
const DYNAMIC_VARIABLE_PATTERN = /\{\{\s*[A-Za-z_][\w.]*\s*\}\}/g;

export const sanitizeMessageForDisplay = (message: string) =>
  message
    .replace(AUDIO_DIRECTION_TAG_PATTERN, '')
    .replace(DYNAMIC_VARIABLE_PATTERN, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\s+([,.!?;:])/g, '$1')
    .trim();

export const buildConversationContext = (messages: ConversationMessage[]) =>
  messages
    .slice(-30)
    .filter(({ message }) =>
      Boolean(message))
    .map(({ role, message }) =>
      `${role === 'assistant' ? 'AI Companion' : 'Professional'}: ${sanitizeMessageForDisplay(message)}`)
    .join('\n')
    .slice(-6000);
